export const getColumnsAddress = (values, columnLabels) => {
  const { columnsAddressStart, columnsAddressEnd } = values;

  if (!columnsAddressEnd) return [columnsAddressStart];

  const allColumnKeys = columnLabels?.map((label) => label?.value);

  const startIndex = allColumnKeys.findIndex(
    (key) => key === columnsAddressStart
  );
  const endIndex = allColumnKeys.findIndex((key) => key === columnsAddressEnd);

  const selectedColumns = allColumnKeys.slice(startIndex, endIndex + 1);

  return selectedColumns;
};
